import { render } from "./import-users.vue?vue&type=template&id=1819fbca&scoped=true"
import script from "./import-users.vue?vue&type=script&lang=js"
export * from "./import-users.vue?vue&type=script&lang=js"

import "./import-users.vue?vue&type=style&index=0&id=1819fbca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1819fbca"]])

export default __exports__